import React from 'react';

import Paper from '@material-ui/core/Paper';

import * as classes from './FunctionDrawer.module.css';

const ControlDrawer = ({
    connectorsClicked,
    ...props
}) => {

    return (
        <Paper className={classes.Drawer} style={{ 'marginTop': '2px' }}>
            <div className={classes.Column}>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="=" className="fas fa-equals" /></button>
                </div>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="!=" className="fas fa-not-equal" /></button>
                </div>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="&lt;" className="fas fa-less-than" /></button>
                </div>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="&lt;" className="fas fa-less-than-equal" /></button>
                </div>
                <div role="none" className={`${classes.CircleIcon} ${classes.Margin25}`} onClick={connectorsClicked}>
                    <button><i data-key="&gt;" className="fas fa-greater-than" /></button>
                </div>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="&lt;" className="fas fa-greater-than-equal" /></button>
                </div>
            </div>
            <div className={classes.Column}>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>And</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Or</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Not</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>True</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>False</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Null</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>If</button>
                </div>
            </div>
        </Paper>
    );
};

export default ControlDrawer;
